import ReconnectingWebSocket from 'ReconnectingWebSocket'
import Api from './../api'

export default function register(DataLayer) {
    DataLayer.$extend('stationsPlaylists', {
        get(channel, after, limit = 12, offset = 0) {
            return Api.stationsPlaylists.get({ station: channel, after: after.toISOString(), limit, offset })
        },

        _processNowPlayingResponse(error, message) {
            if (error) {
                return Promise.reject(error)
            }

            return Promise.resolve({
                meta: {
                    model: 'StationsPlaylist',
                },
                body: message,
            })
        },
    })

    const NowPlaying = (function NowPlayingController() {
        let cachedResponse = null
        const subscribers = []
        const socket = new ReconnectingWebSocket(process.env.VUE_APP_API_NOW_PLAYING, null, { reconnectInterval: 4000 })
        socket.addEventListener('message', function (event) {
            const rawBody = JSON.parse(event.data)
            const notify = response => {
                cachedResponse = response
                subscribers.forEach(cb => cb(response))
            }
            DataLayer.$wrap(() =>
                Promise.resolve({
                    meta: {
                        model: 'StationsPlaylist',
                    },
                    body: rawBody,
                })
            )()
                .then(notify)
                .catch(() => notify({ body: rawBody }))
        })

        socket.addEventListener('error', function (event) {
            DataLayer.stationsPlaylists._processNowPlayingResponse(event)
        })

        return {
            subscribe: function (cb) {
                subscribers.push(cb)
                cachedResponse && cb(cachedResponse)
                // Clean up subscriptions and prevent them from firing forever
                return function unsubscribe() {
                    const index = subscribers.indexOf(cb)
                    if (index > -1) subscribers.splice(index, 1)
                }
            },
        }
    })()

    // Allow callers to unsubscribe and clean up
    DataLayer.stationsPlaylists.subscribe = cb => NowPlaying.subscribe(cb)
}
